import React, { useEffect, useRef } from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Team.css";

gsap.registerPlugin(ScrollTrigger);

export default function Team() {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const teamMembersRef = useRef([]);

  useEffect(() => {
    // Heading animation
    gsap.fromTo(
      headingRef.current,
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: headingRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      }
    );

    // Team members staggered animation
    gsap.fromTo(
      teamMembersRef.current,
      {
        y: 80,
        opacity: 0,
        scale: 0.9,
        rotationY: -15,
      },
      {
        y: 0,
        opacity: 1,
        scale: 1,
        rotationY: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: "back.out(1.7)",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
          toggleActions: "play none none reverse",
        },
      }
    );

    // Continuous floating animation for profile images
    teamMembersRef.current.forEach((member, index) => {
      if (member) {
        const image = member.querySelector(".team-image-wrapper");
        if (image) {
          gsap.to(image, {
            y: -10,
            duration: 2 + index * 0.3,
            repeat: -1,
            yoyo: true,
            ease: "power1.inOut",
          });
        }
      }
    });
  }, []);

  const teamMembers = [
    {
      name: "Linda Hasi",
      role: "Chief Executive Officer",
      image: "/images/team/lindaH.jpg",
      linkedin: "https://www.linkedin.com/in/linda-hasi-b69b25111/",
      expertise: ["Business Development"],
    },
    {
      name: "Xolani Radebe",
      role: "Chief Technology Officer",
      image: "/images/team/xolani.jpg",
      linkedin: "https://www.linkedin.com/in/radebexf/",
      expertise: ["System Architecture", "Innovation"],
    },
    {
      name: "Olwethu Sokabo",
      role: "Data Analyst",
      image: "/images/team/olwethu.jpg",
      linkedin: "https://www.linkedin.com/in/olwethu-sokabo295/",
      expertise: ["Data Visualization", "Full Stack Development"],
    },
    {
      name: "Nndamulele Chipapa",
      role: "Software Enginneer",
      image: "/images/team/nndamulele.jpeg",
      linkedin: "https://www.linkedin.com/in/nndamulele-chipapa/",
      expertise: ["Machine Learning", "Analytics"],
    },
  ];

  return (
    <section
      ref={sectionRef}
      className="team-section py-5"
      style={{
        background: "#0F0C1F",
        position: "relative",
        overflow: "hidden",
      }}
      id="team"
    >
      {/* Background decoration */}
      <div className="team-bg-decoration"></div>

      <Container className="position-relative" style={{ zIndex: 2 }}>
        {/* Section Header */}
        <div ref={headingRef} className="text-center mb-5">
          {/* <div
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4 mx-auto"
            style={{
              background:
                "linear-gradient(135deg, rgba(105, 54, 244, 0.2), rgba(139, 92, 246, 0.2))",
              border: "1px solid rgba(105, 54, 244, 0.3)",
              display: "inline-block",
            }}
          >
            <i className="fa-solid fa-users" style={{ color: "#A78BFA" }}></i>
            <span className="text-sm font-semibold" style={{ color: "#A78BFA" }}>
              Our Team
            </span>
          </div> */}

          <h2 className="text-4xl md:text-5xl font-bold mb-3 text-white">
            Meet the Experts
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            A diverse team of technology leaders, innovators, and specialists dedicated to 
            delivering exceptional ICT solutions
          </p>
        </div>

        {/* Team Grid */}
        <Row className="g-4 justify-content-center">
          {teamMembers.map((member, index) => (
            <Col
              key={index}
              md={6}
              lg={3}
              ref={(el) => (teamMembersRef.current[index] = el)}
            >
                            <div className="team-card">
                {/* Photo with gradient fade */}
                <div className="team-card-image-wrapper">
                  <img
                    src={process.env.PUBLIC_URL + member.image}
                    alt={member.name}
                    className="team-card-photo"
                  />
                  <div className="team-card-image-fade"></div>
                </div>

                {/* Info */}
                <div className="team-card-body">
                  <div className="team-card-expertise">
                    {member.expertise.map((skill, i) => (
                      <span key={i} className="team-card-badge">{skill}</span>
                    ))}
                  </div>
                  <h5 className="team-card-name">{member.name}</h5>
                  <p className="team-card-role">{member.role}</p>
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="team-linkedin-btn"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* Bottom CTA */}
        {/* <div className="text-center mt-5 pt-4">
          <p className="text-gray-400 mb-3">
            Want to join our innovative team?
          </p>
          <a
            href="#contact1"
            className="btn rounded-pill px-4 py-2"
            style={{
              background: "linear-gradient(135deg, #6936F4, #8B5CF6)",
              color: "white",
              border: "none",
              fontWeight: 600,
            }}
          >
            <i className="fa-solid fa-envelope me-2"></i>
            Get in Touch
          </a>
        </div> */}
      </Container>
    </section>
  );
}